import { Instagram, Facebook } from "lucide-react";
import { CONTACT_EMAIL, HERO, SOCIAL, scrollToId } from "../../lib/content";
import { Logo } from "./Logo";

const linkCls = "text-[#F4EBDD]/80 hover:text-[#F2C98F] transition-colors duration-200";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#2C221E] text-[#FDFBF7]">
    <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16 py-16 sm:py-20">
      <div className="flex flex-col gap-12 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <Logo light testId="footer-logo" />
          <p data-testid="footer-tagline" className="mt-5 font-serif italic text-lg text-[#F4EBDD]/85">{HERO.tagline}</p>
        </div>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-10 gap-y-4 text-base">
          <button data-testid="footer-home-link" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className={linkCls}>Home</button>
          <button data-testid="footer-about-link" onClick={() => scrollToId("founder")} className={linkCls}>About</button>
          <a data-testid="footer-contact-link" href={`mailto:${CONTACT_EMAIL}`} className={linkCls}>Contact</a>
        </nav>
        <div className="flex gap-3">
          <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" aria-label="Woven on Instagram" data-testid="footer-instagram-link" className="social-btn"><Instagram className="h-5 w-5" /></a>
          <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" aria-label="Woven on Facebook" data-testid="footer-facebook-link" className="social-btn"><Facebook className="h-5 w-5" /></a>
        </div>
      </div>
      <div className="mt-14 border-t border-[#F4EBDD]/15 pt-8 text-sm text-[#F4EBDD]/60">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Woven. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
